// 共通ユーティリティ（副作用なし）
export const REDUCE_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const onReady = (fn) => {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn, { once: true });
};